<template>
   <div style="width:100%; height:100vh;">
		<div v-if="!openSale" class="counter">
			<img src="https://cdn-nuxt.wegow.com/static/img/68c8405.svg" alt="Conciertos Wegow" class="logo-wegow">
			<div class="flex">
				<h2>¡Hola! La venta de entradas para el concierto de <b>Belen Aguilera</b> comienza a las <b>18:00</b> del 19/12/2023.</h2>
				<h2>A esta hora la web se recargará automáticamente. ES IMPORTANTE QUE NO REFRESQUES LA PÁGINA. ¡Muchas gracias!</h2>
			</div>
		</div>
		<!-- <div v-if="openSale" style="width:100%; height:10vh;">La venta se habrirá dentro de poco</div> -->
		<iframe v-if="openSale" src="https://www.wegow.com/es-es/widget/belen-aguilera-en-sevilla" class="openIframe" frameborder="0"></iframe>
		<div v-else class="closeIframe">
		</div>
	</div>
</template>
<script>
import Vue from 'vue'
import VueGtag from 'vue-gtag'

Vue.use(VueGtag, {
  config: {
    id: 'G-V5SVM4LZ1D',
    anonymizeIp: true,
    ecommerce: {
      enabled: true
    },
  },
  enabled: true,
})

export default {
	data() {
		return {
			// finishTime: new Date('2023', '11', '19', '18', '00', '0', '0').getTime(),
			finishTime: 1703005200000,
			openSale: false,
			difference: 0,
			maxMinutesDelay: 1,
			minSecondsDelay: 0,
			interval: null
		}
	},
	created() {
		let actialTime = new Date().getTime();
		this.openSale = ((this.finishTime - actialTime)/1000) < this.difference;
		if (!this.openSale) {
			this.difference = Math.floor(Math.random() * ((this.maxMinutesDelay * 60)- this.minSecondsDelay) + this.minSecondsDelay);
			this.interval = setInterval(async () => {
				let actialTime = new Date().getTime();
				if ((((this.finishTime - actialTime)/1000) + this.difference) < 0) {
					if ( this.$gtag && typeof this.$gtag.event === 'function' ) {
						this.$gtag.event('reload-landing', {
							'event_category': 'belen-aguilera-sevilla'
						});
					}
					setTimeout(() =>{
						window.location.reload();
					}, 250)
					
				}
			},250);
		}
		
	}, 
	mounted() {
    setTimeout(() => {
      if ( this.$gtag && typeof this.$gtag.event === 'function' ) {
        this.$gtag.event('visit-landing', {
          'event_category': 'belen-aguilera-sevilla'
        })
      }
    }, 2500);

	}
}
</script>

<style>
body {
	overflow-y: hidden;
	background-color: #000000 !important;
}
.openIframe {
	width: 100%;
  height: 100vh;
}
.closeIframe {
	width: 100%;
  height: 90vh;
}
.counter{
	color: white;
	display: flex;
	justify-content: center;
	width: 100%;
	height: 10vh;
}
.logo-wegow {
	width: 64px;
	margin-right: 64px;
}
.flex {
	color: white;
	display: flex;
	flex-direction: column;
	justify-content: center;
	margin-right: 64px;
}
h2 {
	font-size: 1.2em;
	text-align: center;
}
b{
	color: #14caba
}
			
@media (max-width: 900px) {
	.counter {
		flex-direction: column;
    align-items: center;
    height: 25vh;
    z-index: 100;
    position: relative;
		padding: 24px 8px 0px 8px;
	}
	.logo-wegow {
		width: 64px;
    margin-right: 0px;
    margin-left: 0px;
    margin-top: 24px;
    margin-bottom: 12px;
	}
	.flex {
		margin-right: 12px;
		margin-left: 12px;
	}
	h2 {
		font-size: 1em;
	}
	
	.closeIframe {
		width: 100%;
    height: 75vh;
    margin-top: -50px;
    z-index: 1;
    position: relative;
	}
}

</style>
